module.exports = __webpack_public_path__ + "static/media/icon-failed.ec51f8a8.svg";